/**
* @brandOverride URBNWeb
*/
import { decodeClientData } from '../../../core/js/utils/decodeUtils';

export const productInitialState = Object.assign(
    {},
    {
        product: window.productData ? decodeClientData(window.productData).product : {},
        quickshop: {},
        registry: {}
    }
);

export default productInitialState;
